module.exports = __webpack_public_path__ + "img/02_full.4afe32a9.jpg";